import Reveal from "@/components/Reveal";
import SectionHeader from "@/components/SectionHeader";
import { useLanguage } from "@/i18n/LanguageContext";

export default function Roadmap() {
  const { t } = useLanguage();
  const phases = t("roadmap.phases");
  return (
    <section id="roadmap" className="scroll-mt-24 px-4 py-24 sm:px-6 lg:px-8" data-testid="roadmap-section">
      <div className="mx-auto max-w-7xl">
        <SectionHeader kicker={t("roadmap.kicker")} title={t("roadmap.title")} id="roadmap" />
        <div className="grid gap-5 md:grid-cols-2 lg:grid-cols-4">
          {phases.map((p, i) => (
            <Reveal key={p.t} delay={0.07 * i}>
              <article
                data-testid={`roadmap-phase-${i + 1}`}
                className="group relative h-full rounded-xl border border-red-900/30 bg-[#140A0D] p-6 transition-colors hover:border-yellow-700/50"
              >
                <p className="mb-4 font-mono text-[10px] uppercase tracking-[0.3em] text-yellow-600">Phase {i + 1}</p>
                <div aria-hidden="true" className="mb-5 h-px w-full bg-gradient-to-r from-red-800/60 to-transparent" />
                <h3 className="mb-2 text-lg font-bold text-zinc-100">{p.t}</h3>
                <p className="text-sm leading-relaxed text-zinc-400">{p.d}</p>
              </article>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
}
